import PunchCard from './punch-card';

export default PunchCard;
